export const COLOR_DISABLED = '#8090BB';

export const COLOR_ENABLED = '#5B36F2';

export const COLOR_TEXT_INFO = '#161D1F';

export const TEXT_CLASS = 'UTP+class';

export const EXAM_TITLES: Record<string, string> = {
  examsFinals: 'Exámenes finales',
  examsLagging: 'Exámenes rezagados',
  examsReturn: 'Devolución de exámenes'
};

export const HEADERS_TABLE_EXAMS = [
  'Curso',
  'Hora de inicio',
  'Hora fin',
  'Sobre',
  'Ambiente',
  'Acceso'
];

export const COLUMNS_DEVICE_EXAMS = {
  deviceXL: ['332px', '70px', '110px', '90px', '132px', '210px'],
  deviceLG: ['332px', '70px', '110px', '90px', '132px', '180px'],
  deviceMD: ['332px', '70px', '110px', '80px', '132px', '180px'],
  deviceSM: ['332px', '70px', '110px', '50px', '60px', '90px']
};

export const ALIGNMENTS_ROW_EXAMS = [
  'start',
  'end',
  'end',
  'end',
  'center',
  'start'
];

export const EXCLUDED_COLUMNS = [
  'id',
  'modality',
  'isDisabled',
  'floor',
  'address',
  'urlExamClass',
  'campus',
  'pavilion',
  'sede',
  'lat',
  'long'
];
